import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrganizationSubscriptionDetail,
  subscribeToPlan,
} from "../../api/subscription";
import { toast } from "react-toastify";
import { updateOrganizationSubscription } from "../../redux/features/organization-slice";
import { updateLoadingSubscription } from "../../redux/features/subscription-slice";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../constants/routes";
import { storage } from "../../helpers/storage";

const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
const PAYPAL_URL = process.env.REACT_APP_PAYPAL_URL;

const PayPalButton = ({ planId }) => {
  const { id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const getOrganizationSubscriptionDetail = () => {
    if (organization_id) {
      fetchOrganizationSubscriptionDetail(organization_id)
        .then((res) => {
          if (organization_id === res.data?.organization_id) {
            const subscription_data = res.data;

            storage.set(
              "organizationSubscription",
              JSON.stringify(subscription_data)
            );
            dispatch(
              updateOrganizationSubscription({
                subscription: subscription_data,
              })
            );
          }
        })
        .catch((err) => {});
    }
  };

  useEffect(() => {
    const existingScript = document.getElementById("paypal-script");
    if (!existingScript) {
      const script = document.createElement("script");
      script.id = "paypal-script";
      script.src = `${PAYPAL_URL}/sdk/js?client-id=${PAYPAL_CLIENT_ID}&vault=true&intent=subscription`;
      script.dataset.sdkIntegrationSource = "button-factory";
      script.async = true;

      script.onload = () => {
        if (window.paypal) {
          window.paypal
            .Buttons({
              style: {
                disableMaxWidth: true,
                shape: "rect",
                color: "gold",
                layout: "vertical",
                label: "paypal",
              },
              createSubscription: (data, actions) => {
                return actions.subscription.create({
                  plan_id: planId,
                });
              },
              onApprove: (data, actions) => {
                actions.subscription
                  .get()
                  .then((details) => {
                    dispatch(updateLoadingSubscription({ loading: true }));
                    const subscription_data = {
                      plan_id: planId,
                      payment_method: "paypal",
                      paypal_subscription_id: data?.subscriptionID,
                      paypal_order_id: data?.orderID,
                    };
                                  toast.dismiss(); toast.info(
                      `Processing your subscription, please don't exit.`
                    );

                    subscribeToPlan(organization_id, subscription_data)
                      .then((res) => {
                        if (res.data?.status) {
                          getOrganizationSubscriptionDetail();
                                              toast.dismiss(); toast.success(
                            "Your organization is subscribed to the plan successfully."
                          );
                          navigate(ROUTES.checkout.path);
                        } else {
                          if (res.data?.message) {
                                                  toast.dismiss(); toast.error(res.data?.message);
                          } else {
                                                  toast.dismiss(); toast.error("Error while processing your payment!");
                          }
                        }
                      })
                      .catch((err) => {
                        if (err?.response?.data?.message) {
                                              toast.dismiss(); toast.error(err?.response?.data?.message);
                        } else {
                                              toast.dismiss(); toast.error("Error while processing your payment!");
                        }
                      })
                      .finally(() => {
                        dispatch(updateLoadingSubscription({ loading: false }));
                      });
                  })
                  .catch((error) => {
                    console.error("Error with the subscription: ", error);
                  });
              },
              onError: (err) => {
                console.error("PayPal Button Error:", err);
                alert(
                  "There was an error with the PayPal transaction. Please try again."
                );
              },
              onCancel: (data) => {
                console.log("PayPal transaction was cancelled:", data);
              },
            })
            .render(`#paypal-button-container-${planId}`)
            .catch((error) => {
              console.error("Error with the subscription: ", error);
            });
        }
      };

      document.body.appendChild(script);

      return () => {
        script.remove();
      };
    }
  }, [planId]);

  return <div id={`paypal-button-container-${planId}`} />;
};

export default PayPalButton;
